import { StrategyStats } from './StrategyStats';
import { StrategyMeta } from './StrategyMeta';
import { StrategyResults } from './StrategyResults';

export class Strategy {
  constructor(name: string, interval: string, meta?: StrategyMeta) {
    this.name = name;
    this.interval = interval;
    if (meta != undefined) {
      this.meta = meta;
    }
    else {
      this.meta = new StrategyMeta('', [], '');
    }

    this.backtest = [];
    this.paper = [];
    this.live = [];
  }

  getTypeResults(type: string) {
    let results = this.backtest;
    if (type == 'paper') {
      results = this.paper;
    }
    else if (type == 'live') {
      results = this.live;
    }
    return results;
  }

  name: string;
  interval: string;
  meta: StrategyMeta;
  backtest: StrategyResults[];
  paper: StrategyResults[];
  live: StrategyResults[];
}
